
import BaseRadio from "@/components/base/BaseRadio.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import BaseSvg from "@/components/base/BaseSvg.vue";
import useModeOfTravel from "@/composables/useModeOfTravel";
import { typeOfTravel } from "@/config/typeOfTravel";
import { ModeOfTravelEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "TripModeOfTravel",
  props: {
    disabled: Boolean,
  },
  components: {
    BaseSection,
    BaseRadio,
    BaseSvg,
  },
  setup() {
    const { getBooking } = useBookingStore();

    const { selectMode } = useModeOfTravel();

    const modeOfTravel = computed(() => {
      return getBooking.modeOfTravel;
    });

    return { typeOfTravel, modeOfTravel, ModeOfTravelEnum, selectMode };
  },
});
